import { render } from "./administrators.vue?vue&type=template&id=96bd558a&scoped=true"
import script from "./administrators.vue?vue&type=script&lang=js"
export * from "./administrators.vue?vue&type=script&lang=js"

import "./administrators.vue?vue&type=style&index=0&id=96bd558a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-96bd558a"

export default script